<nav class="navbar navbar-dark app-header header header-sticky">
    <div class="navbar-brand">
        <a (click)="onLogoClick()" title="Ir a Inicio">
            <img [src]="logo" alt="CEXVEG" width="157" height="44" />
        </a>
        <button cHeaderToggler  [cSidebarToggle]="sidebarId" title="Menú" class="navbar-toggler" type="button">
            <span class="navbar-toggler-icon"></span>
        </button>
        <button *ngIf="sidebarShown$ | async" name="btnToggle" class="navbar-toggler" type="button" [title]="togglerTitle" (click)="toggleMinimizerSidebar()">
            <i class="fa fa-toggler" [ngClass]="getToggleIcon()"></i>
        </button>
    </div>
    <ul ngbNav class="navbar-nav flex-row ml-md-auto d-md-flex">
        <li ngbNavItem>
            <app-async-info></app-async-info>
        </li>
        <li ngbNavItem>
            <div *ngIf="!isUserLogged && (loginPanelShown$ | async) === false ">
                <a (click)="login()" title="Iniciar Sesión">Iniciar Sesión</a>
            </div>
            <ng-container *ngIf="isUserLogged">
                <a>
                    <i class="fa fa-user" title="{{ loggedUser?.Nombre}} {{ loggedUser?.Apellidos }}"></i>
                </a>
            </ng-container>
        </li>
        <li ngbNavItem>
            <ng-container *ngIf="isUserLogged">
                <a title="Cerrar Sesión" (click)="logOut()">
                    <i class="fa fa-power-off"></i>
                </a>
            </ng-container>
        </li>
    </ul>
</nav>